import React from "react";
import { useHistory } from "react-router-dom";
import successPng from "../assets/images/success.png";
import "../styles/unknowncrash.css";

const ThanksPage = () => {
  const history = useHistory();
  return (
    <div className="something-went-wrong-container">
      <div className="something-went-wrong-title" data-testid="something-went-wrong">
        <div className="img-success">
          <img src={successPng} />
        </div>
        <h6>Thanks for trying the iSelfie Test. Your results are recorded.</h6>
      </div>
      <div className="something-went-wrong-gotohome" data-testid="gotoHomepage" onClick={() => history.push("/home")}>
        <button>Go to Home</button>
      </div>
    </div>
  );
};

export default ThanksPage;
